import type { ContentObjectView, JournalNote } from 'models';
import { Col, Row } from 'ui';
import { ContentObjectFooter } from '../../content-object-footer';
import { ContentObjectHeader } from '../../content-object-header';
import { ContentObjectPreview } from '../../content-object-preview';
import { useCreateActions } from '../post-content-object/hooks';
import { PostContentObjectBody } from '../post-content-object/post-content-object-body';

type P = {
  item: JournalNote;
  onShowComments?: () => void;
  view: ContentObjectView;
};

const JournalContentObject = ({ item, onShowComments, view }: P) => {
  const { actions, contexts, editModal } = useCreateActions({ item, view });

  return (
    <Row gutter={[0, 'ms']}>
      <Col span={24}>
        <ContentObjectHeader actions={actions} item={item} view={view} />
      </Col>

      <Col span={24}>
        <PostContentObjectBody item={item} showReadMore={view !== 'other'} />
      </Col>

      <Col span={24}>
        <ContentObjectFooter
          item={item}
          onShowComments={onShowComments}
          preview={<ContentObjectPreview item={item} view="other" />}
          view={view}
        />
      </Col>
      {contexts}
      {editModal}
    </Row>
  );
};

export default JournalContentObject;
